"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const reporting_chip_model_1 = require("./reporting-chip-model");
class MeasureModel extends reporting_chip_model_1.ReportingChipModel {
    constructor(id, currencyId = null) {
        super(id, currencyId);
    }
    static fromJSON(measure) {
        // for backward compatibility check if measure is object or only number like in old versions
        if (measure instanceof Object) {
            return new MeasureModel(measure.id, measure.currencyId);
        }
        else {
            return new MeasureModel(measure);
        }
    }
}
exports.MeasureModel = MeasureModel;
//# sourceMappingURL=measure.model.js.map